import React, { useEffect } from 'react';
import { useState } from 'react';

import NavBar from './com/navBar/navBar';
import handle from '../../lib/handle';
import Topbar from '../../lib/component/topbar/topbar';
import Selection from './com/selection';
import Publish from './com/publish';
import Original from './com/original';
import Classify from './com/classify';
import statisticsApi from '../../lib/statisticsApi';

export default () => {
  const { topbottom, setShowHrefList, setShowSearchBox } = handle();
  useEffect(() => {
    setShowHrefList(false);
    setShowSearchBox(false);
  }, []);
  useEffect(() => {
    statisticsApi.statisticsApi(1);
  }, []);

  const [showWhat, setShowWhat] = useState<number>(Number(localStorage.getItem('showWhat')) || 1);
  const selectionArr = [
    () => {
      setShowWhat(2);
    },
    () => {
      setShowWhat(3);
    },
    null,
    null,
    null,
    () => {
      setShowWhat(4);
    },
  ];
  useEffect(() => {
    if (showWhat) {
      localStorage.setItem('showWhat', showWhat.toString());
    }
  }, [showWhat]);

  var vh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  return (
    <>
      <div style={{ position: 'fixed', top: 0, zIndex: 123456, width: '100%' }}>
        <Topbar {...{ showLeftIcon: true, topbarTitle: '书城', rightIcon: 'search' }}></Topbar>
      </div>
      <NavBar {...{ showWhat: showWhat, setShowWhat: setShowWhat }}></NavBar>
      <div style={topbottom(78, 0, true)}>
        <div style={{ display: showWhat === 1 ? 'block' : 'none', height: `${vh - 78}px`, overflow: 'scroll' }}>
          <Selection {...{ fnArr: selectionArr }}></Selection>
        </div>
        <div style={{ display: showWhat === 2 ? 'block' : 'none', height: `${vh - 78}px`, overflow: 'scroll' }}>
          <Publish></Publish>
        </div>
        <div style={{ display: showWhat === 3 ? 'block' : 'none', height: `${vh - 78}px`, overflow: 'scroll' }}>
          <Original></Original>
        </div>
        <div style={{ display: showWhat === 4 ? 'block' : 'none', height: `${vh - 78}px`, overflow: 'scroll' }}>
          <Classify></Classify>
        </div>
      </div>
    </>
  );
};
